/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import SearchBar from 'material/searchbar/searchbar';
import ImageTypes from 'material/embeds/imageapi/controller/imagetypes/imagetypes';
import Field from 'material/form/field/field_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/controller/controller_styles';


/* ========== ~~~~~~~~~~ IMAGE API : CONTROLLER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Controller extends Component {
    constructor(props) {
        super(props);
    };

    handleChange = (e) => this.props.tabSelect(e.target.value);

    render() {
        return (
            <div className={`controls ${this.props.classes.controls}`}>
                <div className={`innerControls`}>
                    {/* wide view */}
                    <ImageTypes selectAction={this.props.tabSelect} selected={this.props.tab} options={[
                        { name:'giphy', text:'Giphy' },
                        { name:'images', text:'Images' },
                        { name:'yourOwn', text:'Your Own' }
                    ]}/>

                    {/* thinner view */}
                    <Field type={`select`} name={`imagetype`} defaultValue={this.props.tab} handleChange={this.handleChange} options={[
                        { name:'giphy', value:'giphy', text:'Giphy' },
                        { name:'images', value:'images', text:'Images' },
                        { name:'yourOwn', value:'yourOwn', text:'Your Own' }
                    ]} />

                    {/* search bar */}
                    {this.props.tab !== 'yourOwn' ? <SearchBar placeholder={`Search ...`} onChange={e => this.props.saveSearchTerm(e)} /> : null}
                </div>
            </div>
        )
    };
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Controller);